const url = process.env.VUE_APP_API_URL + "power_ball/winners"

export default {
  namespaced: true,

  state: {
    records: [],
    recordsLoading: false,
    verifyError: null,
    verifyLoading: false,
    unverifyError: null,
    unverifyLoading: false,
    approveError: null,
    approveLoading: false,
    // refreshJackpotPrizeLoading: false,
    // luckyFourPrizes: {},
    // generatePdfError: null,
    // generatePdfLoading: false,
    // sendGeneratePdfError: null,
    // sendGeneratePdfLoading: false,
  },
  mutations: {
    setRecords(state, val) {
      state.records = val
    },

    setRecordsLoading(state, val) {
      state.recordsLoading = val
    },

    setVerifyError(state, val) {
      state.verifyError = val
    },

    setVerifyLoading(state, val) {
      state.verifyLoading = val
    },

    setUnverifyError(state, val) {
      state.unverifyError = val
    },

    setUnverifyLoading(state, val) {
      state.unverifyLoading = val
    },

    setApproveError(state, val) {
      state.approveError = val
    },

    setApproveLoading(state, val) {
      state.approveLoading = val
    },

    // setRefreshJackpotPrizeLoading(state, val) {
    //   state.refreshJackpotPrizeLoading = val
    // },

    // setLuckyFourPrizes(state, val) {
    //   state.luckyFourPrizes = val
    // },

    // setGeneratePdfError(state, val) {
    //   state.generatePdfError = val
    // },

    // setGeneratePdfLoading(state, val) {
    //   state.generatePdfLoading = val
    // },

    // setSendGeneratePdfError(state, val) {
    //   state.sendGeneratePdfError = val
    // },

    // setSendGeneratePdfLoading(state, val) {
    //   state.sendGeneratePdfLoading = val
    // },
  },

  actions: {
    async getRecords({ commit, rootState }, data) {
      commit("setRecordsLoading", true)

      try {
        const response = await fetch(`${url}/${data}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${rootState.userToken}`,
          }
        });

        const res = await response.json()

        if (!response.ok) {
          throw { response, res }
        } else {
          commit("setRecords", res.records)
        }
      } catch (error) {
        const errorStatus = error.response.status

        if (errorStatus == 401) {
          commit("setError", "Unauthorized", { root: true })
        } else {
          commit("setPopUpError", "Something went wrong, please try again!", { root: true })
        }
      } finally {
        commit("setRecordsLoading", false)
      }
    },

    async verify({ commit, rootState }, data) {
      commit("setVerifyLoading", true)

      try {
        const response = await fetch(`${url}/verify`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${rootState.userToken}`,
          },
          body: data
        });

        const res = await response.json()

        if (!response.ok) {
          throw { response, res }
        } else {
          commit("setVerifyError", null)
        }
      } catch (error) {
        const errorStatus = error.response.status

        commit("setVerifyError", "Error") // Decoy error to detect success

        if (errorStatus == 401) {
          commit("setError", "Unauthorized", { root: true })
        } else if (errorStatus == 417) {
          commit("setPopUpError", error.res.error, { root: true })
        } else {
          commit("setRefreshError", "An error occurred, please try again!", { root: true })
        }
      } finally {
        commit("setVerifyLoading", false)
      }
    },

    async unverify({ commit, rootState }, data) {
      commit("setUnverifyLoading", true)

      try {
        const response = await fetch(`${url}/unverify`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${rootState.userToken}`,
          },
          body: data
        });

        const res = await response.json()

        if (!response.ok) {
          throw { response, res }
        } else {
          commit("setUnverifyError", null)
        }
      } catch (error) {
        const errorStatus = error.response.status

        commit("setUnverifyError", "Error") // Decoy error to detect success

        if (errorStatus == 401) {
          commit("setError", "Unauthorized", { root: true })
        } else if (errorStatus == 417) {
          commit("setPopUpError", error.res.error, { root: true })
        } else {
          commit("setRefreshError", "An error occurred, please try again!", { root: true })
        }
      } finally {
        commit("setUnverifyLoading", false)
      }
    },

    async approve({ commit, rootState }, data) {
      commit("setApproveLoading", true)

      try {
        const response = await fetch(`${url}/approve`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${rootState.userToken}`,
          },
          body: data
        });

        const res = await response.json()

        if (!response.ok) {
          throw { response, res }
        } else {
          commit("setApproveError", null)
        }
      } catch (error) {
        const errorStatus = error.response.status

        if (errorStatus == 401) {
          commit("setError", "Unauthorized", { root: true })
        } else if (errorStatus == 403) {
          commit("setApproveError", 'Agent points are insufficient.')
        } else if (errorStatus == 417) {
          commit("setPopUpError", error.res.error, { root: true })
        } else {
          commit("setRefreshError", "An error occurred, please try again!", { root: true })
        }
      } finally {
        commit("setApproveLoading", false)
      }
    },

    // async doRefreshJackpotPrize({ commit, rootState }, data) {
    //   commit("setRefreshJackpotPrizeLoading", true)

    //   try {
    //     const response = await fetch(`${url}/refresh_jackpot_prize`, {
    //       method: 'POST',
    //       headers: {
    //         'Authorization': `Bearer ${rootState.userToken}`,
    //       },
    //       body: data
    //     });

    //     const res = await response.json()

    //     if (!response.ok) {
    //       throw { response, res }
    //     } else {
    //       commit("setLuckyFourPrizes", res.lucky_four_prizes);
    //       alert('Refreshed Successfully.')
    //     }
    //   } catch (error) {
    //     const errorStatus = error.response.status

    //     if (errorStatus == 401) {
    //       commit("setError", "Unauthorized", { root: true })
    //     } else if (errorStatus == 417) {
    //       commit("setPopUpError", error.res.error, { root: true })
    //     } else {
    //       commit("setRefreshError", "An error occurred, please try again!", { root: true })
    //     }
    //   } finally {
    //     commit("setRefreshJackpotPrizeLoading", false)
    //   }
    // },

    // async generateBetsPdf({ commit, rootState }, data) {
    //   commit("setGeneratePdfLoading", true)

    //   try {
    //     const response = await fetch(`${url}/generate_pdf`, {
    //       method: 'POST',
    //       headers: {
    //         'Authorization': `Bearer ${rootState.userToken}`,
    //       },
    //       body: data
    //     });

    //     const res = await response.json()

    //     if (!response.ok) {
    //       throw { response, res }
    //     } else {
    //       commit("setGeneratePdfError", null)

    //       return res
    //     }
    //   } catch (error) {
    //     const errorStatus = error.response.status

    //     commit("setGeneratePdfError", "Error") // Decoy error to detect success

    //     if (errorStatus == 401) {
    //       commit("setError", "Unauthorized", { root: true })
    //     } else if (errorStatus == 417) {
    //       commit("setPopUpError", error.res.error, { root: true })
    //     } else {
    //       commit("setRefreshError", "An error occurred, please try again!", { root: true })
    //     }
    //   } finally {
    //     commit("setGeneratePdfLoading", false)
    //   }
    // },

    // async sendGenerateBetsPdf({ commit, rootState }, data) {
    //   commit("setSendGeneratePdfLoading", true)

    //   try {
    //     const response = await fetch(`${url}/email_generated_pdf` , {
    //       method: 'POST',
    //       headers: {
    //         'Authorization': `Bearer ${rootState.userToken}`,
    //       },
    //       body: data
    //     });

    //     const res = await response.json()

    //     if (!response.ok) {
    //       throw { response, res }
    //     } else {
    //       commit("setSendGeneratePdfError", null)
    //     }
    //   } catch(error) {
    //     const errorStatus = error.response.status

    //     commit("setSendGeneratePdfError", "Error") // Decoy error to detect success

    //     if (errorStatus==401) {
    //       commit("setError", "Unauthorized", { root: true })
    //     } else if (errorStatus==417) {
    //       commit("setPopUpError", error.res.error, { root: true })
    //     } else {
    //       commit("setRefreshError", "An error occurred, please try again!", { root: true })
    //     }
    //   } finally {
    //     commit("setSendGeneratePdfLoading", false)
    //   }
    // },
  }
}